import FullCalendar from '@fullcalendar/react';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import dayGridPlugin from '@fullcalendar/daygrid'; // a plugin!
import { useRef, useState } from 'react';
import AppointmentTooltip from './AppointmentTooltip';
import { getAppointmentStatusColor } from '../../utilities/appointments';
import { useDispatch } from 'react-redux';
import moment from 'moment';
import { getAppointmentByFilter } from '../../store';
import {
  getAppointmentAllEndDateFilter,
  getAppointmentAllStartDateFilter,
} from '../../modules/appointments/utils/helpers';
import { storeInLocal } from '../../lib/storage';
import { useSelector } from 'react-redux';
import { useAuth } from '@frontegg/react';
import { Bars } from 'react-loader-spinner';
import { analytics } from 'src/services';

export default function Calendar({
  data,
  // onChangeHandler,
  isfilterOn,
  startIndex,
  filterValue,
  setFilterValue,
  setIsFilterOn,
  fetchCounterRef,
}) {
  const dispatch = useDispatch();
  const { currentPractitioner } = useSelector(
    (state) => state?.practitionerState
  );

  const { tableLoader } = useSelector((state) => state?.appointmentState);

  const [showAppointmentDetails, setShowAppointmentDetails] = useState(false);
  const [viewAppointment, setViewAppointment] = useState();

  const viewChange = useRef();
  const { user } = useAuth();

  const onChangeHandler = async (value, fieldName, dates) => {
    storeInLocal(
      `${currentPractitioner?.org_uuid}_show_current_practitioner`,
      false
    );
    if (fieldName === 'dateRange') {
      const [start, end] = dates;
      const startDate = start ? moment(start).format('YYYY-MM-DD') : '';
      const endDate = end ? moment(end).format('YYYY-MM-DD') : '';

      setFilterValue({
        ...filterValue,
        startDate: startDate,
        endDate: endDate,
        patientName: '',
        patientId: '',
      });

      if (
        (startDate && endDate) ||
        filterValue?.doctorName?.length > 0 ||
        filterValue.status
      ) {
        analytics.track('Applied Date Range Filter in Calendar view', {
          start_date: start,
          end_date: end,
          email: user?.email,
        });
        dispatch(
          getAppointmentByFilter(
            filterValue?.doctorName?.[0] === '' ? [] : filterValue?.doctorName,
            '',
            getAppointmentAllStartDateFilter(startDate),
            getAppointmentAllEndDateFilter(endDate),
            filterValue?.status === null ? '' : filterValue.status,
            'normal',
            startIndex,
            '',
            'start_date',
            'desc'
          )
        );
        setIsFilterOn(true);
      } else {
        fetchCounterRef.current = 0;
        setIsFilterOn(false);
      }
    }
  };

  const mapToFullCalendarEvents = (dataArray) => {
    return dataArray.map((item) => {
      const dateStr = item.appointmentDateTime;
      const cleanedDate = dateStr.date.replace(/(st|nd|rd|th|,)/g, '').trim();
      const dateTimeString = `${cleanedDate.split(' ')[0]} ${cleanedDate.split(' ')[1]} ${cleanedDate.split(' ')[2]} ${dateStr.time}`;
      const isoDateTime = new Date(dateTimeString).toISOString();
      const title = item.patient_Name;

      return {
        id: item.appointment_id,
        title,
        start: isoDateTime,
        appt_uuid: item.appt_uuid,
        intakeStatus: item.intakeStatus,
        condition_name: item.condition_name,
        patient_Name: item.patient_Name,
        patient_id: item.patient_id,
        dateofBirth: item.dateofBirth,
        practitioner_Name: item.practitioner_Name,
        classNames: 'p-1',
        backgroundColor: getAppointmentStatusColor(item.intakeStatus).bgColor,
        textColor: getAppointmentStatusColor(item.intakeStatus).textColor,
        ...item,
      };
    });
  };

  function handleEventClick(clickInfo) {
    setShowAppointmentDetails(true);
    setViewAppointment(clickInfo.event.extendedProps);
  }

  const fullCalendarEvents = mapToFullCalendarEvents(data);
  const handleDateRangeSelect = (startDate, endDate) => {
    onChangeHandler(null, 'dateRange', [startDate, endDate]);
  };

  const handleViewChange = (viewInfo) => {
    handleDateRangeSelect(viewInfo.start, viewInfo.end);
    mapToFullCalendarEvents(data);
  };

  return (
    <div className="relative">
      {tableLoader && (
        <div className="absolute inset-0 flex justify-center items-center bg-gray-200 bg-opacity-50">
          <Bars
            height="40"
            width="40"
            color="#00D090"
            ariaLabel="bars-loading"
            wrapperClass="pt-1 sm:pt-2 flex justify-center items-center"
          />
        </div>
      )}
      <FullCalendar
        plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
        headerToolbar={{
          left:
            filterValue?.practitionerNames?.length > 0
              ? 'prev today next customPractitionerFilter'
              : 'prev today next',
          center: 'title',
          right: 'timeGridDay,timeGridWeek,dayGridMonth',
        }}
        customButtons={
          filterValue?.practitionerNames?.length > 0
            ? {
                customPractitionerFilter: {
                  text: `Showing appointments for : ${filterValue.practitionerNames.join(', ')}`,
                  hint: 'Current filter selection',
                },
              }
            : {}
        }
        dayMaxEvents={9}
        eventClick={handleEventClick}
        events={fullCalendarEvents}
        ref={viewChange}
        initialView="timeGridDay"
        datesSet={handleViewChange}
      />
      <AppointmentTooltip
        showAppointmentDetails={showAppointmentDetails}
        setShowAppointmentDetails={setShowAppointmentDetails}
        viewAppointment={viewAppointment}
        startIndex={startIndex}
        isfilterOn={isfilterOn}
        filteredData={data}
        filterValue={filterValue}
      />
    </div>
  );
}
